export const convertStringToKebabCase = (string) => {
  return encodeURIComponent(string.replace(/\s+/g, '-').replace(/^-+|-+$/g, '').toLowerCase());
}

export const convertStringToTitleCase = (string) => {
	return string.replace(/[-_]/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\w\S*/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()});
}

export const returnIframeSrc = (iframeCode) => {
  const start = iframeCode.indexOf('src="') + 5;
  const end = iframeCode.indexOf('"', start + 1);
  return iframeCode.substring(start, end);
};

/**
 * Returns a random hex color string like "#a3f9c1".
 */
export const getRandomHexColor = () => `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0')}`;

/**
 * Returns "black" or "white" depending on contrast with the given background color.
 * 
 * @param {string} hexColor - A hex color string like "#a3f9c1" or "a3f9c1".
 * @param {'black'|'white'} [lightText='white'] - The text color to use for dark backgrounds.
 * @param {'black'|'white'} [darkText='black'] - The text color to use for light backgrounds.
 * @returns {string} "black" or "white"
 */
export const getContrastTextColor = (hexColor, lightText = 'white', darkText = 'black') => {
  if (!hexColor) return;
  // Remove leading "#"
  const hex = hexColor.replace('#', '');

  // Parse r, g, b
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate luminance (per ITU-R BT.709)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If luminance is high, return dark text, else light text
  return luminance > 0.5 ? darkText : lightText;
};
